import { Sync } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Scrollbars from "react-custom-scrollbars-2";

const MuiTabs = ({
    tabData,
    variant,
    value,
    bgcolor,
    buttonColor,
    showRefresh,
    handleChange,
    handleRefreshClick,
    isHeaderTabs = false, // New prop to identify header tabs
})=>{
    return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: isHeaderTabs ? "transparent" : "#0a0e1a",
            borderRadius: 0,
            overflow: "hidden",
            p: 0,
            gap: 0,
            borderBottom: isHeaderTabs ? 'none' : '1px solid rgba(255, 255, 255, 0.08)',
            width: '100%',
            height: isHeaderTabs ? 'var(--tab-height)' : 'var(--tab-height)',
            minHeight: isHeaderTabs ? 'var(--tab-height)' : 'var(--tab-height)',
            boxShadow: isHeaderTabs ? 'none' : '0 1px 2px rgba(0, 0, 0, 0.2)'
          }}
        >
            {tabData &&
              tabData.map((tab, i) => (
                <Button
                  key={i}
                  disableTouchRipple
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.3,
                    px: 0.75,
                    py: 0,
                    borderRadius: 0,
                    background: i === value
                      ? 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)'
                      : 'transparent',
                    color: i === value ? '#ffffff' : 'rgba(255, 255, 255, 0.5)',
                    fontWeight: i === value ? 700 : 500,
                    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
                    fontSize: 'var(--font-size-xs)',
                    height: 'calc(var(--tab-height) - 2px)',
                    minHeight: 'calc(var(--tab-height) - 2px)',
                    minWidth: 28,
                    border: i === value ? '1px solid rgba(6, 182, 212, 0.4)' : 'none',
                    borderBottom: i === value ? '2px solid #06b6d4' : 'none',
                    borderTop: 'none',
                    position: 'relative',
                    transition: 'all 0.2s ease',
                    mr: 0,
                    textTransform: 'none',
                    letterSpacing: '0.01em',
                    boxShadow: i === value ? '0 2px 8px rgba(6, 182, 212, 0.3)' : 'none',
                    '&:hover': {
                      background: i === value
                        ? 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)'
                        : 'rgba(255, 255, 255, 0.08)',
                      color: i === value ? '#ffffff' : 'rgba(255, 255, 255, 0.8)',
                    },
                  }}
                  variant="text"
                  color={buttonColor ? buttonColor : "secondary"}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleChange(i);
                  }}
                >
                  {tab.icon && (
                    <Box sx={{
                      fontSize: 'var(--icon-size-sm)',
                      display: 'flex',
                      alignItems: 'center',
                    }}>
                      {tab.icon}
                    </Box>
                  )}
                  <Typography sx={{
                    fontWeight: 'inherit',
                    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
                    fontSize: 'inherit',
                    color: 'inherit',
                    ml: tab.icon ? 0.3 : 0,
                    whiteSpace: 'nowrap',
                  }}>{tab.label}</Typography>
                  {i === value && showRefresh && (
                    <IconButton
                      sx={{ p: 0, mx: 0.5 }}
                      onClick={() => handleRefreshClick?.(i)}
                    >
                      <Sync sx={{ color: "text.primary", fontSize: 'var(--icon-size-sm)' }} />
                    </IconButton>
                  )}
                </Button>
              ))}
          </Box>
      );

};
export default MuiTabs;